import { Modal, Form, Input, Button } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { transactionLaneDataHandle } from "../../Rtd/state/actions";

const AddEmailSellerAgentWyoming = ({
    isSellerAgentEmail,
    agentsData,
    setIsSellerAgentEmail,
    userAuthKey,
    offerId,
    openFor,
    source,
    setCallPropertyDocsApi
}) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    
    const missingEmailAgents = useMemo(
        () => agentsData?.filter(agent => !agent?.email) || [],
        [agentsData]
    );

    const handleCancel = () => {
        setIsSellerAgentEmail(false);
        form?.resetFields();
    };

    useEffect(() => {
        if (isSellerAgentEmail) {
            form?.setFieldsValue({
                agents: missingEmailAgents?.map(() => ({ email: "" }))
            });
        }
    }, [isSellerAgentEmail, missingEmailAgents, form]);

    const handleOk = (values) => {
        const sellerAgentDetail = missingEmailAgents?.map((agent, idx) => ({
            fullName: agent.fullName,
            key: agent.key,
            email: values?.agents[idx]?.email
        }));

        const data = {
            sellerAgentDetail,
            offerId,
            openFor,
        };

        dispatch(
            transactionLaneDataHandle.addEmailFun({
                data,
                userAuthKey,
                source,
                setCallPropertyDocsApi,
                origin:"WY"
            })
        );

        setIsSellerAgentEmail(false);
        form?.resetFields();
    };

    return (
        <Modal
            title={<div className="commonModalTitle">Add Email</div>}
            visible={isSellerAgentEmail}
            onCancel={handleCancel}
            footer={false}
        >
            <Form
                form={form}
                layout="horizontal"
                onFinish={handleOk}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                labelAlign="left"
            >
                {missingEmailAgents?.map((agent, idx) => (
                    <Form.Item
                        key={idx}
                        label={agent?.fullName}
                        name={["agents", idx, "email"]}
                        rules={[
                            { required: true, message: "Please enter email" },
                            { type: "email", message: "Invalid email format" },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value) return Promise.resolve();

                                    const emails =
                                        getFieldValue("agents")?.map(a =>
                                            a?.email?.trim().toLowerCase()
                                        ) || [];
                                    const currentEmail = value.trim().toLowerCase();
                                    const count = emails?.filter(e => e === currentEmail).length;

                                    if (count > 1) {
                                        return Promise.reject(
                                            new Error("This email is already used!")
                                        );
                                    }
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    >
                        <Input placeholder="Enter email" />
                    </Form.Item>
                ))}

                <Form.Item shouldUpdate  wrapperCol={{ span: 8, offset: 10 }}>
                    {() => (
                        <Button
                            // style={{ marginLeft: "65%" }}
                            type="primary"
                            htmlType="submit"
                            disabled={
                                !form?.isFieldsTouched(true) ||
                                form?.getFieldsError().some(({ errors }) => errors.length > 0) ||
                                missingEmailAgents?.some((_, idx) => !form?.getFieldValue(["agents", idx, "email"]))
                            }
                        >
                            Done
                        </Button>
                    )}
                </Form.Item>

            </Form>
        </Modal>
    );
};

export default AddEmailSellerAgentWyoming;